import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=e60ef28c&scoped=true&"
import script from "./AppDetail.vue?vue&type=script&lang=js&"
export * from "./AppDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/appstore-detail.css?vue&type=style&index=0&id=e60ef28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60ef28c",
  null
  
)

export default component.exports